var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDplinkPkDetailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 79,
    viewBox: "0 0 124 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 28.9449C111 54.5164 91.9532 79 66.5503 79C41.1475 79 16.9999 49.313 16.9999 23.7415C16.9999 -1.83005 37.6459 -0.709253 68.0077 10.7825C93.4105 10.7825 111 3.37333 111 28.9449Z",
    fill: "#EFF8FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_11250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 0,
    width: 66,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8593 0.543213H99.1406V67.4555H34.8593V0.543213Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_11250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7302 17.8593L85.5967 1.2033C85.2673 0.787745 84.7802 0.544434 84.2504 0.544434H49.763C49.2333 0.544434 48.7462 0.787745 48.4167 1.2033L35.2833 17.8593C35.0399 18.1602 34.9108 18.5322 34.9108 18.9192V65.7383C34.9108 66.6835 35.6843 67.457 36.6295 67.457H97.3686C98.3139 67.457 99.0873 66.6835 99.0873 65.7383V18.9192C99.1014 18.5327 98.9727 18.1602 98.7294 17.8598L98.7302 17.8593ZM94.061 17.4868H68.7257V3.98112H83.4201L94.061 17.4868ZM50.5941 3.98112H65.2885V17.4868H39.9532L50.5941 3.98112ZM38.349 64.019V20.924H95.6509V64.019H38.349Z",
    fill: "#76A6CE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.156 34.7583L63.6412 46.273L58.8579 41.4896C58.185 40.8168 57.096 40.8168 56.4231 41.4896C55.7503 42.1625 55.7503 43.2515 56.4231 43.9244L62.4241 49.9254C62.7536 50.2548 63.1977 50.4265 63.6418 50.4265C64.0859 50.4265 64.5154 50.2548 64.8594 49.9254L77.5773 37.2075C78.2501 36.5346 78.2501 35.4456 77.5773 34.7728C76.9179 34.0849 75.8294 34.0849 75.1561 34.7583L75.156 34.7583Z",
    fill: "#76A6CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.607 38.1732C112.672 33.7991 118.043 24.5405 123 22.4991",
    stroke: "#B9CFE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.347 35.6355C118.277 35.3566 120.443 34.5757 121.67 33.6831",
    stroke: "#B9CFE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3548 34.2237C15.1765 29.7469 5.65577 20.3457 0.999939 18.5549",
    stroke: "#B9CFE1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57338 31.7659C6.91532 32.079 9.97495 32.7052 11.4779 32.7052",
    stroke: "#B9CFE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplinkPkDetailLogo);
export default __webpack_public_path__ + "static/media/dplink-pk-detail-logo.a8a480291871368f21158562b16a3803.svg";
export { ForwardRef as ReactComponent };